import { Action, createReducer, on } from '@ngrx/store';
import {
  initialUserConnection,
  UserConnectionsModel
} from '../states/user-connections.model';
import {
  followUnFollowUserConnectionError,
  followUnFollowUserConnectionSuccess,
  followUserConnection,
  loadGroupMembers,
  loadMoreGroupMembers,
  loadMoreUserConnectionSuccess,
  loadPeopleToFollow,
  loadUserConnectionError,
  loadUserConnectionFollowers,
  loadUserConnectionFollowing,
  loadUserConnectionMutual,
  loadUserConnectionSuccess,
  searchUsers,
  unFollowUserConnection
} from '../actions/user-connections.action';
import { lightUserStateInitial } from '../states/light-user-state.model';

const reducer = createReducer(
  initialUserConnection,

  on(loadPeopleToFollow, state => ({
    ...state,
    connections: [],
    pageInfo: null,
    error: '',
    loading: true
  })),

  on(loadUserConnectionFollowing, state => ({
    ...state,
    connections: [],
    pageInfo: null,
    error: '',
    loading: true
  })),

  on(loadUserConnectionFollowers, state => ({
    ...state,
    connections: [],
    pageInfo: null,
    error: '',
    loading: true
  })),

  on(loadGroupMembers, state => ({
    ...state,
    connections: [],
    pageInfo: null,
    error: '',
    loading: true
  })),

  on(loadMoreGroupMembers, state => ({
    ...state,
    error: '',
    loading: true
  })),

  on(searchUsers, state => ({
    ...state,
    connections: [],
    pageInfo: null,
    error: '',
    loading: true
  })),

  on(loadUserConnectionMutual, state => ({
    ...state,
    connections: [],
    pageInfo: null,
    error: '',
    loading: true
  })),

  on(loadUserConnectionSuccess, (state, { payload }) => ({
    ...state,
    error: '',
    loading: false,
    pageInfo: payload?.pageInfo || null,
    connections:
      payload.data?.map(lightUser => {
        return {
          ...lightUserStateInitial,
          user: lightUser
        };
      }) || []
  })),

  on(loadMoreUserConnectionSuccess, (state, { payload }) => {
    const newCon =
      payload.data?.map(lightUser => {
        return {
          ...lightUserStateInitial,
          user: lightUser
        };
      }) || [];

    return {
      ...state,
      error: '',
      loading: false,
      pageInfo: payload.pageInfo,
      connections: state.connections.concat(newCon)
    };
  }),

  on(loadUserConnectionError, (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload.message
  })),

  on(followUserConnection, (state, { payload }) => ({
    ...state,
    connections: state.connections.map(con => {
      if (con.user.ID === payload.followeeId) {
        return {
          ...con,
          error: '',
          loading: true
        };
      }
      return con;
    })
  })),

  on(unFollowUserConnection, (state, { payload }) => ({
    ...state,
    connections: state.connections.map(con => {
      if (con.user.ID === payload.followeeId) {
        return {
          ...con,
          error: '',
          loading: true
        };
      }
      return con;
    })
  })),

  on(followUnFollowUserConnectionSuccess, (state, { payload }) => ({
    ...state,
    connections: state.connections.map(con => {
      if (con.user.ID === payload.ID) {
        return {
          ...con,
          error: '',
          loading: false,
          user: {
            ...con.user,
            ifollow: payload.ifollow
          }
        };
      }
      return con;
    })
  })),

  on(followUnFollowUserConnectionError, (state, { payload }) => ({
    ...state,
    connections: state.connections.map(con => {
      if (con.user.ID === payload.userID) {
        return {
          ...con,
          error: payload.message,
          loading: false
        };
      }
      return con;
    })
  }))
);

export function UserConnectionsReducer(
  state: UserConnectionsModel | undefined,
  action: Action
): UserConnectionsModel {
  return reducer(state, action);
}
